import { defineMessages } from "react-intl";

export const smtpWizardMessages = defineMessages({
  wizardTitle: {
    defaultMessage: "Add SMTP Communication Channel",
    id: "smtpWizardMessages.wizardTitle",
  },

  configureMailServer: {
    defaultMessage: "Configure mail server",
    id: "smtpWizardMessages.configureMailServer",
  },

  changeCredTitle: {
    defaultMessage: "Change credential",
    id: "exchangeOnlineWizardMessages.changeCredTitle",
  },

  mailServerAddress: {
    defaultMessage: "Mail server address",
    id: "smtpWizardMessages.mailServerAddress",
  },

  selectRecipients: {
    defaultMessage: "Select recipients",
    id: "smtpWizardMessages.selectRecipients",
  },

  configSender: {
    defaultMessage: "Configure mail sender and recipients",
    id: "smtpWizardMessages.configSender",
  },

  mailServerPort: {
    defaultMessage: "Mail server port",
    id: "smtpWizardMessages.mailServerPort",
  },

  tls: {
    defaultMessage: "Use encrypted connection (TLS)",
    id: "smtpWizardMessages.tls",
  },

  userNameField: {
    defaultMessage: "Username",
    id: "smtpWizardMessages.userNameField",
  },

  passwordField: {
    defaultMessage: "Password",
    id: "smtpWizardMessages.passwordField",
  },

  userAccount: {
    defaultMessage: "User account",
    id: "smtpWizardMessages.userAccount",
  },

  userName: {
    defaultMessage: "User name",
    id: "smtpWizardMessages.userName",
  },

  mailServer: {
    defaultMessage: "Mail server",
    id: "smtpWizardMessages.mailServer",
  },

  mailPort: {
    defaultMessage: "Mail port",
    id: "smtpWizardMessages.mailPort",
  },

  useTLS: {
    defaultMessage: "Use TLS",
    id: "smtpWizardMessages.useTLS",
  },

  username: {
    defaultMessage: "Username",
    id: "smtpWizardMessages.username",
  },

  mailSender: {
    defaultMessage: "Mail sender",
    id: "smtpWizardMessages.mailSender",
  },

  mailRecipients: {
    defaultMessage: "Mail recipients",
    id: "smtpWizardMessages.mailRecipients",
  },

  credentials: {
    defaultMessage: "Credentials",
    id: "smtpWizardMessages.credentials",
  },

  enterCredentials: {
    defaultMessage: "Enter credentials",
    id: "smtpWizardMessages.enterCredentials",
  },

  credentialsSubTitle: {
    defaultMessage: "Enter credentials for SMTP server authentication",
    id: "smtpWizardMessages.credentialsSubTitle",
  },

  onTLS: {
    defaultMessage: "Yes",
    id: "smtpWizardMessages.useTLS",
  },

  offTLS: {
    defaultMessage: "No",
    id: "smtpWizardMessages.useTLS",
  },
});
